import { login, logout } from "@/api/login";
const user = {
    state: {
        token: sessionStorage.getItem("token") || "",
        //用户名
        username: sessionStorage.getItem("username") || "",
        // dh需要用户名
        userNameLogin: sessionStorage.getItem("userNameLogin") || "",
        // dh手机号
        userPhone: sessionStorage.getItem("userPhone") || "",
        // dh邮箱
        userMail: sessionStorage.getItem("userMail") || "",
        //用户id
        userid: sessionStorage.getItem("userid") || "",
        //手机号码
        phone: sessionStorage.getItem("phone") || "",
        //是否主账号
        isPrimary: sessionStorage.getItem("isPrimary") || "",
        //是否登录
        islogin: sessionStorage.getItem("islogin") || false,
        //角色
        roles: [JSON.parse(sessionStorage.getItem("roles"))] || []
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_USERNAME: (state, username) => {
            state.username = username;
        },
        SET_USERNAMELOGIN: (state, userNameLogin) => {
            state.userNameLogin = userNameLogin;
            window.sessionStorage.setItem("userNameLogin", userNameLogin);
        },
        SET_USERPHONE: (state, userPhone) => {
            state.userPhone = userPhone;
            window.sessionStorage.setItem("userPhone", userPhone);
        },
        SET_USERID: (state, userId) => {
            state.userId = userId;
            window.sessionStorage.setItem("userId", userId);
        },
        SET_USERMAIL: (state, userMail) => {
            state.userMail = userMail;
            window.sessionStorage.setItem("userMail", userMail);
        },
        SET_USERID: (state, userid) => {
            state.userids = userid;
        },
        SET_PHONE: (state, phone) => {
            state.phone = phone;
        },
        SET_ISPRIMARY: (state, isPrimary) => {
            state.isPrimary = isPrimary;
        },
        SET_ISLOGIN: (state, islogin) => {
            state.islogin = islogin;
            window.sessionStorage.setItem("islogin", islogin);
        },
        SET_ROLES: (state, roles) => {
            state.roles = [];
            state.roles.push(roles);
        }
    },

    actions: {
        // 登录
        Login({ commit }, loginForm) {
            // const username = userInfo.username.trim();
            return new Promise((resolve, reject) => {
                login(loginForm)
                    .then(response => {
                        if (response.success) {
                            const data = response.data;
                            const roles = response.data.isPrimary
                                ? "main"
                                : "user";
                            // console.log(roles);

                            // const roles =
                            // response.data.isPrimary === 1 ? "main" : "user";
                            // setToken(data.token);
                            commit("SET_TOKEN", data.token);
                            commit("SET_USERNAME", data.username);
                            commit("SET_USERID", data.userid);
                            commit("SET_PHONE", data.phone);
                            commit("SET_ISPRIMARY", data.isPrimary);
                            commit("SET_ROLES", roles);
                            commit("SET_ISLOGIN", true);
                            window.sessionStorage.setItem("token", data.token);
                            window.sessionStorage.setItem(
                                "username",
                                data.username
                            );
                            window.sessionStorage.setItem(
                                "userid",
                                data.userid
                            );
                            window.sessionStorage.setItem("phone", data.phone);
                            window.sessionStorage.setItem(
                                "isPrimary",
                                data.isPrimary
                            );
                            window.sessionStorage.setItem(
                                "roles",
                                JSON.stringify(roles)
                            );
                        } else {
                            commit("SET_ISLOGIN", false);
                        }
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        // 用户名
        changeUserName({ commit }, name) {
            commit("SET_USERNAMELOGIN", name);
        },
        // 手机号
        changeUserPhone({ commit }, phone) {
            commit("SET_USERPHONE", phone);
        },
        // 邮箱
        changeUserMail({ commit }, mail) {
            commit("SET_USERMAIL", mail);
        },
        // 用户id
        changeUserId({ commit }, mail) {
            commit("SET_USERID", mail);
        },

        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                getInfo(state.token)
                    .then(response => {
                        const data = response.data;
                        if (data.roles && data.roles.length > 0) {
                            // 验证返回的roles是否是一个非空数组
                            commit("SET_ROLES", data.roles);
                        } else {
                            reject("获取用户信息失败");
                        }
                        commit("SET_NAME", data.name);
                        commit("SET_AVATAR", data.avatar);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        // 登出
        LogOut({ commit }) {
            return new Promise((resolve, reject) => {
                logout()
                    .then(res => {
                        if (res.success) {
                            commit("SET_TOKEN", "");
                            commit("SET_USERNAME", "");
                            commit("SET_USERID", "");
                            commit("SET_PHONE", "");
                            commit("SET_ISPRIMARY", "");
                            commit("SET_ISLOGIN", false);
                            sessionStorage.clear();
                        }
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        // 前端 登出
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit("SET_TOKEN", "");
                commit("SET_USERNAME", "");
                commit("SET_USERID", "");
                commit("SET_PHONE", "");
                commit("SET_ISPRIMARY", "");
                commit("SET_ISLOGIN", false);
                sessionStorage.clear();
                let href = location.href;
                let index = href.indexOf("#");
                let url = href.substr(0, index);
                window.location.href = url + "#/login";
                resolve();
            });
        }
    }
};

export default user;
